import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-602a9db6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "advantages mediabuying-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "mediabuying-adv-section-wrapper" }
const _hoisted_4 = { class: "mediabuying-section-title" }
const _hoisted_5 = { class: "mediabuying-section-subtitle" }
const _hoisted_6 = { class: "isHidden career__join_text" }
const _hoisted_7 = { class: "advantages__list" }
const _hoisted_8 = { class: "advantages__block" }
const _hoisted_9 = {
  target: "_blank",
  rel: "noopener noreferrer",
  href: "https://t.me/mt_hr_control_bot"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.59532 2.5C3.42642 2.5 1.66675 4.17969 1.66675 6.25V33.75C1.66675 35.8203 3.42642 37.5 5.59532 37.5H34.4048C36.5737 37.5 38.3334 35.8203 38.3334 33.75V6.25C38.3334 4.17969 36.5737 2.5 34.4048 2.5H5.59532ZM13.6882 12.9089C15.2953 12.9089 16.7232 13.4393 17.7746 14.2348C18.7469 14.9732 19.2023 15.7119 19.5996 16.3748L16.8232 17.699C16.6245 17.2642 16.3855 16.8094 15.7718 16.3176C15.0967 15.8057 14.4231 15.6548 13.8465 15.6548C11.5854 15.6548 10.3951 17.662 10.3951 19.8959C10.3951 22.8313 11.9633 24.2881 13.8465 24.2881C15.6716 24.2881 16.4064 23.0764 16.8813 22.301L19.64 23.6453C19.1231 24.4208 18.6272 25.1793 17.5161 25.9163C16.9217 26.314 15.5537 27.0911 13.6091 27.0911C9.89923 27.0911 6.90484 24.5164 6.90484 19.9898C6.90484 16.0339 9.72155 12.9089 13.6882 12.9089ZM19.8661 13.3251H23.5954L26.4912 22.8312L29.366 13.3252H33.0953L28.2354 26.6933H24.6661L19.8661 13.3251Z",
    fill: "white"
  })
], -1))
const _hoisted_11 = { class: "advantages__block" }
const _hoisted_12 = {
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M20.0001 38.3327C30.1256 38.3327 38.3334 30.1248 38.3334 19.9993C38.3334 9.87385 30.1256 1.66602 20.0001 1.66602C9.87458 1.66602 1.66675 9.87385 1.66675 19.9993V38.3327H20.0001ZM11.6667 13.3327C10.7463 13.3327 10.0001 14.0789 10.0001 14.9993C10.0001 15.9198 10.7463 16.666 11.6667 16.666H26.6667C27.5872 16.666 28.3334 15.9198 28.3334 14.9993C28.3334 14.0789 27.5872 13.3327 26.6667 13.3327H11.6667ZM11.6667 19.9993C10.7463 19.9993 10.0001 20.7455 10.0001 21.666C10.0001 22.5865 10.7463 23.3327 11.6667 23.3327H26.6667C27.5872 23.3327 28.3334 22.5865 28.3334 21.666C28.3334 20.7455 27.5872 19.9993 26.6667 19.9993H11.6667ZM11.6667 26.666C10.7463 26.666 10.0001 27.4122 10.0001 28.3327C10.0001 29.2532 10.7463 29.9993 11.6667 29.9993H20.0001C20.9206 29.9993 21.6667 29.2532 21.6667 28.3327C21.6667 27.4122 20.9206 26.666 20.0001 26.666H11.6667Z",
    fill: "white"
  })
], -1))
const _hoisted_14 = { class: "advantages__block" }
const _hoisted_15 = {
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M34.9999 10.0007H31.6666V25.0007H9.99992V28.334C9.99992 29.2507 10.7499 30.0007 11.6666 30.0007H29.9999L36.6666 36.6673V11.6673C36.6666 10.7507 35.9166 10.0007 34.9999 10.0007ZM28.3333 20.0007V5.00065C28.3333 4.08398 27.5833 3.33398 26.6666 3.33398H4.99992C4.08325 3.33398 3.33325 4.08398 3.33325 5.00065V28.334L9.99992 21.6673H26.6666C27.5833 21.6673 28.3333 20.9173 28.3333 20.0007Z",
    fill: "white"
  })
], -1))
const _hoisted_17 = { class: "media__btn" }
const _hoisted_18 = { class: "career__join_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('hiring.sub')), 1),
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('hiring.title')), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('hiring.text')), 1),
          _createVNode(_component_Button, {
            outlined: "",
            type: "button",
            onClick: _ctx.onRequest,
            class: "adv__btn isHidden",
            text: this.$t('btn.join'),
            centered: ""
          }, null, 8, ["onClick", "text"])
        ])
      ]),
      _createElementVNode("ul", _hoisted_7, [
        _createElementVNode("li", _hoisted_8, [
          _createElementVNode("a", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('hiring.connect')), 1)
          ])
        ]),
        _createElementVNode("li", _hoisted_11, [
          _createElementVNode("a", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('hiring.zoom')), 1)
          ])
        ]),
        _createElementVNode("li", _hoisted_14, [
          _createElementVNode("a", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('hiring.zoom')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('hiring.text')), 1),
        _createVNode(_component_Button, {
          outlined: "",
          type: "button",
          onClick: _ctx.onRequest,
          text: this.$t('btn.join'),
          centered: ""
        }, null, 8, ["onClick", "text"])
      ])
    ])
  ]))
}